import axios from "axios";
import ITest from "../types/test.type";
import { AuthService } from "./auth.service";

const API_URL = "/api/v1.0/test";

export class TestService {
  public static async getLatestTests() {
    const config = {
      headers: AuthService.getAuthHeaders(),
    };
    return axios
      .get(API_URL + "/latest", config)
      .then((response) => {
        return response.data;
      })
      .catch(console.log);
  }

  public static async getTestsById(m360id: string): Promise<ITest[]> {
    const config = {
      headers: AuthService.getAuthHeaders(),
    };
    return axios.get(API_URL + "/m360id/" + m360id, config).then((response) => {
      return response.data as ITest[];
    });
  }

  public static async getTestsByImei(imei: string): Promise<ITest[]> {
    const config = {
      headers: AuthService.getAuthHeaders(),
    };
    return axios.get(API_URL + "/imei/" + imei, config).then((response) => {
      return response.data as ITest[];
    });
  }

  public static async assignTestToProduct(
    productNumber: string,
    m360Id: string
  ) {
    const config = {
      headers: AuthService.getAuthHeaders(),
    };
    return axios
      .post(
        API_URL + "/assignTestToProduct",
        {
          productNumber,
          m360Id,
        },
        config
      )
      .then((response) => {
        return response.data;
      })
      .catch(console.log);
  }
}
